module.exports = __webpack_public_path__ + "img/before.ceabdcac.png";